import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './FloatingCart.css';

export default function FloatingCart() {
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    const updateCount = () => {
      try {
        const cart = JSON.parse(localStorage.getItem('engimitra_cart') || '[]');
        setCartCount(cart.length);
      } catch (e) {
        setCartCount(0);
      }
    };
    
    updateCount();
    window.addEventListener('storage', updateCount);
    const interval = setInterval(updateCount, 500);

    return () => {
      window.removeEventListener('storage', updateCount);
      clearInterval(interval);
    };
  }, []);

  return (
    <Link to="/cart" className="cp-fab" aria-label="View Cart">
      {cartCount > 0 && <span className="cp-fab-badge">{cartCount}</span>}
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="21" r="1"></circle>
        <circle cx="20" cy="21" r="1"></circle>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
      </svg>
    </Link>
  );
}
